import nestAxios from './_nestAxios'

export const get = _id => nestAxios.get(`/activos-fijos-inventarios-fisicos/${_id}`)

export const nuevoCodigo = () => nestAxios.get('/activos-fijos-inventarios-fisicos/nuevo-codigo')

export const nuevo = data => nestAxios.post('/activos-fijos-inventarios-fisicos', data)

export const actualizar = (_id, data) => nestAxios.put(`/activos-fijos-inventarios-fisicos/${_id}`, data)

export const registrarConteo = (_id, data) => nestAxios.post(`/activos-fijos-inventarios-fisicos/${_id}/conteo`, data)

export const cambiarEstado = (_id, data) => nestAxios.put(`/activos-fijos-inventarios-fisicos/${_id}/estado`, data)

export const eliminar = _id => nestAxios.delete(`/activos-fijos-inventarios-fisicos/${_id}`)
